export const C_WAF_PROTECTION = {
  COOKIE_AWS_WAF_TOKEN: 'aws-waf-token',
  TITLE_ERROR_GET_TOKEN: 'AWS WAF - Get Token',
  MODAK_API_PARTIAL_URLS: ['.modak.live', '.modak.zone'],
  HEADERS: {
    ACTION: {
      KEY: 'x-amzn-waf-action',
      VALUES: {
        CHALLENGE: 'challenge',
      },
    },
    MODAK_WAF: {
      KEY: 'x-modak-waf',
      VALUES: {
        TRUE: 'true',
      },
    },
  },
};
